// extracted by mini-css-extract-plugin
module.exports = {"root":"Searchbar_root__0UY3r","label":"Searchbar_label__8naSC","button":"Searchbar_button__RF3f_","input":"Searchbar_input__uOAb6"};